module.exports = __webpack_public_path__ + "img/data-center10.11c98fdd.png";